export default "__VITE_ASSET__CVMKoXmu__"